import { isNotNullOrUndefined } from '@deltasierra/type-utilities';
import { BuilderTemplateGalleryUrlMap } from '../../../../../pages/builderTemplateGallery/Router.url';
import { LCOFragmentForLocationGroupThumbnail } from './__graphqlTypes/LCOFragmentForLocationGroupThumbnail';

export function useLocationGroupBuilderTemplateGalleryLink(
    locationCategoryOption: LCOFragmentForLocationGroupThumbnail,
): string | null {
    const builderTemplateCategoryLegacyIds = locationCategoryOption.builderTemplateCategories
        .map(btc => btc.legacyId)
        .filter(isNotNullOrUndefined);

    if (!(builderTemplateCategoryLegacyIds.length > 0)) {
        return null;
    }

    // DSL-6919: This is the legacy dashboard for brands. We don't use this page anymore so I'm not updating the link
    return `${BuilderTemplateGalleryUrlMap.index.url()}?category=${builderTemplateCategoryLegacyIds.join(',')}`;
}
